<template>
    <!-- 右边主体[[ -->
    <div class="g-content g-autofixheight task-square">
        <!-- 活动广场详情[[ -->
        <div class="header">
            <div class="header-title">活动详情</div>
        </div>
        <div class="task-square-con task-square-detail">
            <div class="detail-top">
                <h5 class="detail-tit">{{task.title}}</h5>
                <div class="detail-top-inf f-inlineblock-top">
                    <img class="detail-head-portrait f-inlineblock-top" v-if="task.game_logo != undefined" :src="task.game_logo">
                    <p class="f-inlineblock-top detail-top-name">{{task.game_name}}</p>
                </div>
                <p class="detail-top-time f-inlineblock-top"><span class="time-num f-inlineblock-top" v-show="task.start_time">{{task.start_time | dateFormat('/')}} - {{task.end_time | dateFormat('/')}}</span></p>
                <p class="detail-top-time f-inlineblock-top"><span class="time-num f-inlineblock-top">活动总奖励： <span class="money-text">{{task.budget | moneyFormat(0)}}</span> 元</span></p>
            </div>
            <div class="activity-con task-detail-rich" v-html="task.mission_desc"></div>
            <div class="channel-part">
                <div class="channel-box f-fl">
                    <span class="channel-title">推广官方渠道</span>
                    <div class="channel-cnt f-hide-col-1">
                        {{Object.keys(task.channels).join(' , ')}}
                    </div>
                    <div class="channel-pop office-channel g-scrollbar">
                        <ul class="account-list">
                            <li class="account-item" v-for="(item,index) of Object.keys(task.channels)" :key="index">
                                <div class="item-media">
                                    <span class="item-text f-hide-col-1">{{item}}</span>
                                </div>
                                <div>
                                    <div class="item-account" v-for="(channel,index) of task.channels[item]" :key="index">
                                        <span class="item-text f-hide-col-1">{{channel}}</span>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="channel-box f-fr">
                    <span class="channel-title">推广分发账号</span>
                    <div class="channel-cnt f-hide-col-1">
                        <img class="channel-logo" v-for="(item,index) of task.medias" :key="index" :src="item.logo" :title="item.name">
                        <span class="ellipsis" v-show="Object.keys(task.medias).length>9">...</span>
                    </div>
                    <div class="channel-pop g-scrollbar">
                        <ul class="account-list">
                            <li class="account-item" v-for="(item,index) of task.medias" :key="index">
                                <div class="item-media">
                                    <img class="channel-logo" :src="item.logo">
                                    <span class="item-text f-hide-col-1">{{item.name}}</span>
                                </div>
                                <div>
                                    <div class="item-account" v-for="(account,index) of item.account" :key="index">
                                        <img class="channel-logo" :src="account.accountAvatar ? account.accountAvatar : item.logo">
                                        <span class="item-text f-hide-col-1">{{account.accountName}}</span>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="g-tab">
                <a href="javascript:;" v-for="(item,index) of customTabList" :key="index" @click="changTab(item.val)">
                    <div class="g-tab-item" :class="{'g-tab-item-active': nowTab === item.val}">{{item.text}}</div>
                </a>
            </div>
            <ul class="freelance-list normal">
                <li class="list-empty f-clearfix" v-if="!articleList.length">
                    <img src="~Assets/img/pages/v4/search-null.png"/>
                </li>
                <li class="list" v-for="(article,index) in articleList" :key="index">
                    <div class="f-clearfix">
                        <p class="pic f-fl" @click="preview(article,nowTab === 1 ? '' : 'no')" style="cursor: pointer">
                            <img class="pic-img" :src="article.cover" alt="">
                        </p>
                        <div class="txt f-fl">
                            <h3 class="title">
                                <span class="type">{{ getArticleType(article) }}</span>
                                <a class="name f-hide-col-1 js-open-view" href="javascript:;" @click="preview(article)">{{ article.articleTitle }}</a>
                            </h3>
                            <div class="intro f-hide-col-1">
                                <!-- 活动：<span>{{`${article.missionTitle}`}}</span> -->
                            </div>
                            <div class="author">
                                <span class="time">{{ article.created ?  article.created.substr(0,10) : '' }}</span>
                                <span class="game-name">{{ article.gameName ?  article.gameName : '' }}</span>
                                <div class="vid-pop f-fr" v-if="article.vid">
									<span class="vid-pop-title">腾讯视频链接vid</span>
									<div class="vid-pop-cnt">
										<div class="tooltip-arrows-down"></div>
										<p>vid: {{article.vid}}</p>
										<p>链接: {{`https://v.qq.com/x/page/${article.vid}.html`}}</p>
									</div>
								</div>
                            </div>
                            <div class="profit-wrap" v-show="nowTab === 1">
                                收益： <span class="task-money">{{ article.rewardPrice ? article.rewardPrice/100 : '-'}}</span>
                            </div>
                        </div>
                        <div class="operation draft f-fl"> <!-- 0629修改 -->
                            <p class="status">
                                <span class="color-theme" :class="{'full-height': nowTab !== 1}">{{ getArticleStatusText(article.articleStatus)}}</span>
                                <span v-if="article.articleStatus==50" :title="`驳回原因：${article.reject_remark}`" class="reject-remark">？</span>
                            </p>

                            <p class="btn f-clearfix" v-if="nowTab === 1">
                                <a class="g-btn" href="javascript:;"
                                   v-if="[10,50].includes(article.articleStatus) && [30,40,50].includes(task.mission_status)"
                                   @click="editArticle(article)">编辑
                                </a>
                                <a class="g-btn preview-video" href="javascript:;" v-if="article.operation.preview" @click="preview(article)">预览</a>
                                <a class="g-btn js-open-reject" href="javascript:;"
                                   v-if="[10,50].includes(article.articleStatus) && [30,40,50].includes(task.mission_status)"
                                   @click="deleteArticle(article)">删除</a>
                            </p>
                            <!-- 任务状态,
                            10:审批中
                            20：已驳回
                            30：已发布
                            40:已征满
                            50：已过期
                            55：奖励待确认
                            60:待结算
                            70：结算中
                            80：结算驳回
                            90：支付中
                            100:支付成功
                            110：支付失败 -->
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <!-- 活动广场详情 ]] -->
        <div class="footer-bar">
            <div class="footer-bar-btn">
                <div class="g-bottom-btn btn-group">
                    <router-link class="button f-fr" :to="{name:'v4-task-playground'}">返回</router-link>
                    <!--选中状态  为a标签添加类 active -->
                    <a v-if="task.mission_status == 30 && task.video" class="button active f-fr" href="javascript:;" @click="videoContribute(taskId)">视频投稿</a>
	                <a v-if="task.mission_status == 30 && task.text" class="button active f-fr" href="javascript:;" @click="pictureContribute(taskId)">图文投稿</a>
                </div>
            </div>
        </div>
        <!-- 分页[[ -->
        <pagination
                v-show="paginationConf.total >0"
                :total="paginationConf.total"
                :page-size="paginationConf.pageSize"
                @change="pageChange"
                ref="pager">
        </pagination>
        <!-- 分页]] -->

        <!--内容预览 start-->
        <content-preview ref="contentPreview"></content-preview>
        <video-preview ref="videoPreview"></video-preview>
        <real-name-pop ref="realNamePop"></real-name-pop>
        <!--内容预览 end-->
    </div>
    <!-- 右边主体]] -->
</template>
<style lang="scss" scoped>
    @import '~Assets/sass/pages/v4/contribute/task.scss';
    .full-height{
        line-height: 100px;
    }
    .g-tab{
        border-bottom: 1px solid #f1f1f1;
    }
    .list-empty{
        margin-top: 20px;
        text-align: center;
        margin-bottom: 180px;
    }
    .vid-pop{
        position: relative;
        margin-right: 30px;
        color: #FD7E28;
        &:hover{
            .vid-pop-cnt{
                display: block;
            }
        }
        .vid-pop-title{
            padding: 0 0 20px 0;
        }
        .vid-pop-cnt{
            display: none;
            width: 340px;
            position: absolute;
            right: -120px;
            top: 30px;
            z-index: 1;
            background: #fff;
            padding: 13px 20px;
            box-sizing: border-box;
            color: #FD7E28;
            font-size: 14px;
            line-height: 26px;
            box-shadow: 0 0 10px 0 rgba(214, 214, 214, 0.5);
            border: 1px solid #ebebeb;
            border-radius: 2px;
            .tooltip-arrows-down{
                position: absolute;
                top: -16px;
                left: 3px;
                right: 0;
                margin: auto;
                width: 0;
                height: 0;
                display: inline-block;
                border-style: solid;
                border-width: 10px 7px 7px;
                border-color: transparent transparent #ebebeb transparent;
                &::before{
                    position: absolute;
                    display: inline-block;
                    content: '';
                    bottom: -8.2px;
                    left: -6.5px;
                    width: 0;
                    height: 0;
                    display: inline-block;
                    border-style: solid;
                    border-width: 10px 7px 7px;
                    border-color: transparent transparent #fff transparent;
                }
            }
        }
    }
</style>
<style>
.task-detail-rich img{
    max-width: 100%;
}
</style>

<script>
import {
    dateFormat
} from 'Filters';
import pagination from 'Components/v4/pagination/pagination_v4';
import contentPreview from 'Components/v4/pop/content_preview';
import videoPreview from 'Components/v4/pop/video_preview';
import {
    TaskDetail, UserUgcIdentity, AllGame, ArticleDetail, ArticleStatistics, ArticleDelete, TaskMyArticleList, TaskMyArticleListAll
} from 'Services/getData.js';
import realNamePop from 'Components/v4/pop/real_name_pop.vue';
export default {
    data() {
        return {
            taskId: 0,
            task: {
                channels: {},
                medias: {}
            },
            paginationConf: {
                total: 0,
                pageSize: 10
            },
            articleList: [],
            articleStat: [],
            articleStatusList: [
                {
                    name: '请选择', id: -1
                },
                {
                    name: '已发布', id: 30
                },
                {
                    name: '已驳回', id: 50
                },
                {
                    name: '已通过', id: 20
                },
                {
                    name: '待审核', id: 10
                },
                {
                    name: '供应商已通过', id: 18
                },
                {
                    name: '发布中', id: 25
                }
            ],
            params: {
                gameId: '',
                type: '',
                title: '',
                missionId: '',
                articleStatus: '', // 内容同步状态 (1同步中 2已同步 3已驳回)
                checkStatus: '', // ugc 验收状态
                status: -1, // -1代表全部
                page: 1,
                pageSize: 10
            },
            userIdentityData: {
                tglVerify: {
                    code: ''
                },
                flowUser: {}
            },
            tabList: [
                {
                    val: 1,
                    text: '我的投稿内容'
                },
                {
                    val: 2,
                    text: '全部投稿内容'
                }
            ],
            nowTab: 1
        }
    },
    components: {
        pagination, contentPreview, videoPreview, realNamePop
    },
    computed: {
        customTabList(){
            return  [96, 97].includes(Number(this.taskId)) ? this.tabList.slice(0, 1):this.tabList
        }
    },
    mounted(){
        this.getTaskId();
        this.getDetail();
        this.getArticleList();
	    this.getArticleStat(7);
        this.getUserIdentity()
    },
    filters: {
        dateFormat
    },
    methods: {
        changTab(val){
            this.nowTab = val;

            this.params.gameId = '';
            this.params.type = '';
            this.params.title = '';
            this.params.articleStatus = '';
            this.params.checkStatus = '';
            this.params.status = -1;
            this.params.page = 1;
            this.params.pageSize = 10;
            this.$refs.pager.reload();

            this.getArticleList();
        },
        async getUserIdentity(){
            let res = await UserUgcIdentity();
            if(res.status && res.data.code == 0){
                this.userIdentityData = res.data.data;
            }
        },
        videoContribute(taskId){
            if(!this.userIdentityData.qqVerify){
                this.$refs.realNamePop.showqqVerify = true;
                return
            }
            if(this.userIdentityData.qqVerify == true && this.userIdentityData.tglAndQqVerify == false){
                this.$refs.realNamePop.showTglAndQqVerify = true;
                return
            }
            this.$router.push({
                name: 'v4-task-video',
                params: {
                    taskId: taskId
                }
            })
        },
        pictureContribute(taskId){
            if(!this.userIdentityData.qqVerify){
                this.$refs.realNamePop.showqqVerify = true;
                return
            }
            if(this.userIdentityData.qqVerify == true && this.userIdentityData.tglAndQqVerify == false){
                this.$refs.realNamePop.showTglAndQqVerify = true;
                return
            }
            this.$router.push({
                name: 'v4-task-picture',
                params: {
                    taskId: taskId
                }
            })
        },
        getTaskId() {
            this.params.missionId = this.$route.params.detailId;
            this.taskId = this.$route.params.detailId;
        },
        async getDetail() {
            let res = await TaskDetail({
                missionId: this.taskId
            });
            if (res.data.code == 0) {
                this.task = res.data.data;
            }
        },
        getArticleList(){
            this.articleList = [];
            if(this.nowTab === 1){
                this.getTaskArticleList();
            }else{
                this.getTaskArticleListAll();
            }
        },
        pageChange (param) {
            // this.params.pageSize = param.pageSize; // 发送给接口的字段
            this.params.page = param.pageIndex; // 发送给接口的字段
            this.getArticleList();
        },
        preview(article, nopreview){
            if(nopreview){
                return;
            }
            if(this.curTab == 0 && this.isDraft){
                if(article.articleType === 0){
                    this.$refs.contentPreview.loadInfo(article.id, true);
                }else{
                    this.$refs.videoPreview.remotePreview(article.id, true);
                }
            }else{
                if(article.articleType == 0){
                    this.$refs.contentPreview.loadInfo(article.id);
                }else if(article.articleType == 1){
                    this.$refs.videoPreview.remotePreview(article.id);
                }else{
                    this.$refs.contentPreview.loadInfo(article.id);
                }
            }
        },
        editArticle(article){
            if (article.articleType == 0) {
                this.$router.history.push({
                    name: 'v4-task-picture', params: {
                        taskId: article.missionId, articleId: article.id
                    }
                });
            } else if (article.articleType == 1) {
                this.$router.history.push({
                    name: 'v4-task-video', params: {
                        taskId: article.missionId, articleId: article.id
                    }
                });
            }
        },
        publishArticle(article){
            this.$router.history.push({
                name: 'v4-contribute-contribute', query: {
                    draftId: article.id
                }
            });
        },
        deleteArticle(article){
            let self = this;
            this.$confirm('确认删除此内容').then(()=>{
                self.doDeleteArticle(article.id);
            }).catch((e) => {
            });
        },
        async doDeleteArticle(id){
            let res = await ArticleDelete(id);
            if(res.status === 200 && res.data.code == 0){
                this.$alert('删除成功');
            }
            this.getArticleList();
        },

        async getArticleStat(type){
            let res = await ArticleStatistics({
                type: type
            });
            let statMap = new Map();
            if(res.status === 200 && res.data.code == 0){
                let stat = res.data.data;
                stat.filter((s)=>{
                    statMap.set(s.status, s.num);
                });
            }
            console.log(statMap)
        },
        async getTaskArticleList(){
            // 我的投稿列表
            let response;
            let param = this.params;
            response = await TaskMyArticleList(param);

            let result = response.data;
            if(result.code == 0){
                this.articleList = result.data.data.map((article)=>{
                    article.operation = {
                        preview: true
                    }
                    return article;
                });
                this.paginationConf.total = result.data.total;
            }
        },
        async getTaskArticleListAll(){
            // 全部投稿列表
            let param = this.params;
            let response = await TaskMyArticleListAll(param);

            let result = response.data;
            if(result.code == 0){
                this.articleList = result.data.data.map((article)=>{
                    article.operation = {
                        preview: true
                    }
                    return article;
                });
                this.paginationConf.total = result.data.total;
            }
        },
        getArticleType(item){
            let type = '';
            switch(parseInt(item.articleType)){
            case 0:
                type = '图文';
                break;
            case 1:
                type = '视频';
                break;
            }
            return `【${type}】`;
        },
        getArticleStatusText(articleStatus){
            let text = '';
            // 活动 : -1全部 30已发布 50已驳回 20已通过 10待审核 18供应商已通过 25发布中
            switch (articleStatus){
            case 30:
                text  ='已发布';
                break;
            case 50:
                text  ='已驳回 ';
                break;
            case 20:
                text  ='已通过 ';
                break;
            case 10:
                text  ='待审核';
                break;
            case 18:
                text  ='供应商已通过';
                break;
            case 23:
            case 25:
                text  ='发布中';
                break;

            }
            return text;
        }
    }
}
</script>